module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-5.5329df2a.svg";